const ChevronUpIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width='12'
      height='8'
      viewBox='0 0 12 8'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path d='M1.41 8L-2.83151e-07 6.47773L6 2.62268e-07L12 6.47773L10.59 8L6 3.05533L1.41 8Z' />
    </svg>
  )
}

export default ChevronUpIcon
